<template>
  <h2 class="pb-2 border-bottom">Serviços Gerais de Cuidados Primários</h2>
  <ul>
    <li>Exames de rotina e cuidados preventivos</li>
    <li>Exames físicos anuais</li>
    <li>Visitas de bem-estar</li>
    <li>Vacinações e imunizações</li>
    <li>Triagens de saúde (pressão arterial, colesterol, diabetes, etc.)</li>
    <li>Gerenciamento de Doenças Crônicas</li>
    <li>Gerenciamento de diabetes</li>
    <li>Controle da hipertensão</li>
    <li>Distúrbios da tireoide</li>
    <li>Colesterol alto</li>
    <li>Obesidade e gerenciamento de peso</li>
    <li>Cuidados Agudos e Visitas de Doenças</li>
    <li>Resfriados, gripes e infecções</li>
    <li>Lesões menores e cuidados com feridas</li>
    <li>Cuidados com alergias e asma</li>
    <li>Dores de cabeça e enxaquecas</li>
    <li>Saúde da Mulher</li>
    <li>Terapia de reposição hormonal (TRH)</li>
    <li>Conselhamento sobre controle de natalidade</li>
    <li>Gerenciamento da menopausa</li>
    <li>Cuidados com SOP e tireoide</li>
    <li>Saúde do Homem</li>
    <li>Terapia de reposição de testosterona (TRT)</li>
    <li>Triagem de saúde da próstata</li>
    <li>Tratamento de disfunção erétil</li>
    <li>Saúde Mental e Cuidados Comportamentais</li>
    <li>Gerenciamento de ansiedade e depressão</li>
    <li>Avaliação e tratamento de TDAH</li>
    <li>Gerenciamento de distúrbios do sono</li>
    <li>Perda de Peso e Saúde Metabólica</li>
    <li>Programas médicos de perda de peso</li>
    <li>Medicamentos prescritos para perda de peso</li>
    <li>Conselhamento nutricional</li>
  </ul>
  <h2 class="pb-2 border-bottom">Serviços Adicionais Que Podemos Oferecer</h2>
  <ul>
    <li>Consultas de Telemedicina</li>
    <li>Terapia IV e Infusões de Vitaminas</li>
    <li>Dermatologia e Cuidados com a Pele (Acne, erupções cutâneas, remoção de pintas)</li>
    <li>Serviços de Saúde Sexual (testes de DST, terapia hormonal)</li>
    <li>Programas de Cessação do Tabagismo</li>
  </ul>
</template>

<script>
export default {
  name: 'ContentPtBR'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
